export const MULTIPLE_STATUSES = [
  {
    color: "#93AAFD",
    name: "Ready",
    statusId: "f63feb60-c2f8-49ed-b099-b7846ecd10b2",
  },
  {
    color: "#FFD80B",
    name: "In Progress",
    statusId: "efaa8fdd-1b4c-4dda-8395-395d15294750",
  },
  {
    color: "#F15252",
    name: "Waiting",
    statusId: "9dae62a0-3f78-4a69-a5f6-240aded90540",
  },
  {
    color: "#47DE96",
    name: "Completed",
    statusId: "7116afd6-80c6-4d00-99da-7b17d782440b",
  },
] as const;
